import { AssignmentActions } from "../../actions/types";
const {
  RESET_ASSIGNMENT,
  UPDATE_DRAG_CLONE,
  UPDATE_POSITIONS,
  UPDATE_SENTENCE,
  UPDATE_ASSIGNMENT_NAME,
  UPDATE_BACK_BUTTON,
} = AssignmentActions;

const initialState = {
  positionsArr: [],
  positionsObj: {},
  dragClone: {},
  sentence: {},
  assignmentName: "",
  backButtonClick: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_ASSIGNMENT:
      return {
        ...state,
        positionsArr: [],
        positionsObj: {},
        dragClone: {},
        sentence: {},
      };
    case UPDATE_DRAG_CLONE:
      return {
        ...state,
        dragClone: action.payload,
      };
    case UPDATE_BACK_BUTTON:
      return {
        ...state,
        backButtonClick: !state.backButtonClick,
      };
    case UPDATE_ASSIGNMENT_NAME:
      return {
        ...state,
        assignmentName: action.payload,
      };
    case UPDATE_POSITIONS:
      return {
        ...state,
        positionsArr: action.arr,
        positionsObj: action.obj,
      };
    case UPDATE_SENTENCE:
      if (action.arr.includes("")) {
        return {
          ...state,
          sentence: {
            ...state.sentence,
            [action.position]: {
              text: [],
              id: action.id,
            },
          },
        };
      }
      return {
        ...state,
        sentence: {
          ...state.sentence,
          [action.position]: {
            text: action.arr,
            id: action.id,
          },
        },
      };
    default:
      return state;
  }
}
